// extracted by mini-css-extract-plugin
export default {"container":"Spinner_container__1dulZ","content":"Spinner_content__PhoLT","characters":"Spinner_characters__UQY4H","text":"Spinner_text__kje3X"};